<h1>Loading...</h1>
<a routerLink="/{{ groupCode }}" class="button button-pill">Continue to Onboarding</a>
<p>or</p>
<a routerLink="/login" class="button button-pill">Login</a>
